import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=3d9937d2&"
import script from "./Dashboard.js?vue&type=script&lang=js&"
export * from "./Dashboard.js?vue&type=script&lang=js&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports